import type { AdditionalPointsPurchase } from "@b2bportal/air-shopping-api";
import type { PointsToCashRedemption } from "@b2bportal/rbc-points-to-cash-api";
import type { RewardsPrice } from "@hopper-b2b/types";
import type { RewardsSelectedOptionType } from "./context";

export enum RewardsPaymentEventTypes {
  SET_REWARDS_SELECTED = "SET_REWARDS_SELECTED",
  SET_REWARDS_AMOUNT_TO_APPLY = "SET_REWARDS_AMOUNT_TO_APPLY",
  CLEAR_REWARDS_PAYMENT_ERROR = "CLEAR_REWARDS_PAYMENT_ERROR",
  SET_REWARDS_ACCOUNT_ID = "SET_REWARDS_ACCOUNT_ID",
  PREVIOUS = "PREVIOUS",
  NEXT = "NEXT",
  SET_BASED_FARE_FIXED_PRICE = "SET_BASED_FARE_FIXED_PRICE",
  SET_ADDITIONAL_POINTS_PURCHASE = "SET_ADDITIONAL_POINTS_PURCHASE",
  CLOSE_ADDITIONAL_POINTS_NOT_ELIGIBLE_MODAL = "CLOSE_ADDITIONAL_POINTS_NOT_ELIGIBLE_MODAL",
  SET_POINTS_REDEMPTION = "SET_POINTS_REDEMPTION",
  SET_POINTS_TO_CASH_LOADING = "SET_POINTS_TO_CASH_LOADING",
}

export interface SetRewardsSelected {
  type: RewardsPaymentEventTypes.SET_REWARDS_SELECTED;
  selectedOption: RewardsSelectedOptionType;
}

export const setRewardsSelected = (
  selectedOption: RewardsSelectedOptionType
): SetRewardsSelected => ({
  type: RewardsPaymentEventTypes.SET_REWARDS_SELECTED,
  selectedOption,
});

export interface SetRewardsAmountToApplyEvent {
  type: RewardsPaymentEventTypes.SET_REWARDS_AMOUNT_TO_APPLY;
  rewardsAmountToApply: RewardsPrice;
}

export const setRewardsAmountToApply = (
  rewardsAmountToApply: RewardsPrice
): SetRewardsAmountToApplyEvent => ({
  type: RewardsPaymentEventTypes.SET_REWARDS_AMOUNT_TO_APPLY,
  rewardsAmountToApply,
});

export interface ClearRewardsPaymentErrorEvent {
  type: RewardsPaymentEventTypes.CLEAR_REWARDS_PAYMENT_ERROR;
}

export interface SetRewardsAccountIdEvent {
  type: RewardsPaymentEventTypes.SET_REWARDS_ACCOUNT_ID;
  rewardsAccountId: string;
}

export interface SetBasedFareFixedPriceEvent {
  type: RewardsPaymentEventTypes.SET_BASED_FARE_FIXED_PRICE;
  baseFareFixedPrice: RewardsPrice;
}

export interface SetAdditionalPointsPurchaseEvent {
  type: RewardsPaymentEventTypes.SET_ADDITIONAL_POINTS_PURCHASE;
  additionalPointsPurchase: AdditionalPointsPurchase;
}

export interface CloseAdditionalPointsNotEligibleModalEvent {
  type: RewardsPaymentEventTypes.CLOSE_ADDITIONAL_POINTS_NOT_ELIGIBLE_MODAL;
}

export interface SetPointsRedemptionEvent {
  type: RewardsPaymentEventTypes.SET_POINTS_REDEMPTION;
  pointsRedemption: PointsToCashRedemption | undefined;
  error: boolean;
}

export const setPointsRedemption = (
  pointsRedemption: PointsToCashRedemption | undefined,
  error = false
): SetPointsRedemptionEvent => ({
  type: RewardsPaymentEventTypes.SET_POINTS_REDEMPTION,
  pointsRedemption,
  error,
});

export interface SetPointsToCashLoadingEvent {
  type: RewardsPaymentEventTypes.SET_POINTS_TO_CASH_LOADING;
  loading: boolean;
}

export const setPointsToCashLoading = (
  loading: boolean
): SetPointsToCashLoadingEvent => ({
  type: RewardsPaymentEventTypes.SET_POINTS_TO_CASH_LOADING,
  loading,
});

export type RewardsPaymentEvents =
  | SetRewardsSelected
  | SetRewardsAmountToApplyEvent
  | ClearRewardsPaymentErrorEvent
  | SetRewardsAccountIdEvent
  | SetBasedFareFixedPriceEvent
  | SetAdditionalPointsPurchaseEvent
  | CloseAdditionalPointsNotEligibleModalEvent
  | SetPointsRedemptionEvent
  | SetPointsToCashLoadingEvent;
